import { render, staticRenderFns } from "./PolicyCardInvestment.vue?vue&type=template&id=206e1009&scoped=true&"
import script from "./PolicyCardInvestment.vue?vue&type=script&lang=ts&"
export * from "./PolicyCardInvestment.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyCardInvestment.vue?vue&type=style&index=0&id=206e1009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e1009",
  null
  
)

export default component.exports